/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { PartOfSpeech } from './PartOfSpeech.js';
import {
    PartOfSpeechFromJSON,
    PartOfSpeechFromJSONTyped,
    PartOfSpeechToJSON,
} from './PartOfSpeech.js';

/**
 * 
 * @export
 * @interface ExtractionToken
 */
export interface ExtractionToken {
    /**
     * 
     * @type {number}
     * @memberof ExtractionToken
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof ExtractionToken
     */
    end?: number;
    /**
     * 
     * @type {PartOfSpeech}
     * @memberof ExtractionToken
     */
    pos?: PartOfSpeech;
}

/**
 * Check if a given object implements the ExtractionToken interface.
 */
export function instanceOfExtractionToken(value: object): boolean {
    return true;
}

export function ExtractionTokenFromJSON(json: any): ExtractionToken {
    return ExtractionTokenFromJSONTyped(json, false);
}

export function ExtractionTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractionToken {
    if (json == null) {
        return json;
    }
    return {
        
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'pos': json['pos'] == null ? undefined : PartOfSpeechFromJSON(json['pos']),
    };
}

export function ExtractionTokenToJSON(value?: ExtractionToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'start': value['start'],
        'end': value['end'],
        'pos': PartOfSpeechToJSON(value['pos']),
    };
}

